export default __webpack_public_path__ + "img/ebc57d000284771f7143a3b4f86be04d.svg";